export function trackPageView(path, title) {
   window.dataLayer = window.dataLayer || []
   window.dataLayer.push({
      event: "page_view",
      page_path: path,
      page_title: title
   })
}
